import Vue from "vue";
import VueRouter from "vue-router";
import TourDetail from "../app";

Vue.use(VueRouter);

const base = process.env.NODE_ENV === "production" ? "/" : "/serp-detail";


export function createRouter (){
  return new VueRouter({
    mode: "history",
    base,
    routes: [
      {
        name: 'detail',
        path: '/tours/:id/:symCode',
        component: TourDetail,
      },
      {
        name: 'detail',
        path: '/tours/:id',
        component: TourDetail,
      }
    ],
  });
}

